import { Component, ElementRef, forwardRef, Input, OnChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EmployeeShort } from '@common/models/employeeShort.model';

const enterKey = 13;
const backspaceKey = 8;

@Component({
  selector: 'app-employees-select-component',
  templateUrl: './employeesSelectComponent.html',
  styleUrls: ['./employeesSelectComponent.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmployeesSelectComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useValue: (c: FormControl) => {
        const err = {
          required: {
            content: 'No employee selected',
          },
        };

        return (Object.keys(c.value).length === 0) ? err : null;
      },
      multi: true,
    },
  ],
})
export class EmployeesSelectComponent implements OnChanges, ControlValueAccessor {
  @Input() employees: EmployeeShort[];
  @Input() formControl: FormControl;
  @ViewChild('employeeInput') employeeInput: ElementRef;
  public employeesFiltrated: EmployeeShort[] = [];
  public showEmployeeList = false;
  public query = '';
  public inputActive = false;
  public selectedEmployees: EmployeeShort[] = [];
  private propagateChange: Function;
  private propagateTouch: Function;

  ngOnChanges() {
    this.employeesFiltrated = this.employees;
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  writeValue(value: EmployeeShort[]) {
    this.selectedEmployees = value;
  }

  onKeyUp($event: KeyboardEvent) {
    if ($event.which === enterKey) {
      if (this.employeesFiltrated.length && this.showEmployeeList) {
        this.selectEmployee(this.employeesFiltrated[0]);
        this.query = '';
      }
    } else if ($event.which === backspaceKey) {
      if (this.query === '') {
        this.deselectLastEmployee();
      } else {
        this.query = (<HTMLInputElement>$event.target).value;
      }
    } else {
      this.onFocusIn();
      this.query = (<HTMLInputElement>$event.target).value;
    }

    this.filtrateEmployees();
  }

  filtrateEmployees() {
    this.employeesFiltrated = this.employees.filter((employee) => {
      const employeeNameMatchesQuery = employee.name.toLowerCase().includes(this.query.toLowerCase());

      let employeeAlreadySelected = false;
      this.selectedEmployees.forEach((selectedEmployee) => {
        if (selectedEmployee.key === employee.key) {
          employeeAlreadySelected = true;
        }
      });

      return employeeNameMatchesQuery && !employeeAlreadySelected;
    });
  }

  selectEmployee(employee) {
    this.selectedEmployees.push(employee);
    this.filtrateEmployees();
    this.query = '';
    this.propagateChange(this.selectedEmployees);
  }

  deselectEmployee($event, employeeToDeselect) {
    $event.stopPropagation();
    this.selectedEmployees = this.selectedEmployees.filter(employee => employee.key !== employeeToDeselect.key);
    this.filtrateEmployees();
    this.propagateChange(this.selectedEmployees);
    this.formControl.markAsUntouched();
  }

  deselectLastEmployee() {
    this.selectedEmployees.splice(-1, 1);
  }

  focusInInput() {
    this.employeeInput.nativeElement.focus();
    this.onFocusIn();
  }

  onFocusIn() {
    this.inputActive = true;
    this.showEmployeeList = true;
  }

  onFocusOut() {
    this.showEmployeeList = false;
    this.formControl.markAsTouched();
    this.inputActive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/addEditTaskView/EmployeesSelectComponent/employeesSelectComponent.ts